export default __webpack_public_path__ + "static/media/headphones@2x.848cdc40.png";